import { Component } from 'react';
import PropTypes from 'prop-types';

class ConvertDate extends Component {
  render() {
    const { unix } = this.props;
    if (unix === '') {
      return '-';
    }

    let result = '';
    const date = new Date(Number(unix));
    const months = ['janvāris', 'februāris', 'marts', 'aprīlis', 'maijs', 'jūnijs', 'jūlijs', 'augusts', 'septembris', 'oktobris', 'novembris', 'decembris'];
    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();
    result = `${year}. gada ${day}. ${month}`;

    return result;
  }
}

ConvertDate.propTypes = {
  unix: PropTypes.string,
};

ConvertDate.defaultProps = {
  unix: '',
};

export default ConvertDate;
